module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/la-80cf2b55ad4d86b51967de1bc8a5b7f8.svg";